// extracted by mini-css-extract-plugin
module.exports = {"publishedAt":"News_publishedAt__2fqhj","image":"News_image__13bIu"};